const About = () => {
    // In a real app, you might get the version from package.json
    const appVersion = "2.0.0";
    const appName = "Stopwatch App";

    return (
        <div className="text-center text-sm text-neutral-500 dark:text-neutral-400 py-4">
            <p>{appName} - Version {appVersion}</p>
            <div className="mt-2 space-x-4">
                <a href="/terms" className="hover:underline">Terms of Service</a>
                <span>&bull;</span>
                <a href="/privacy" className="hover:underline">Privacy Policy</a>
            </div>
        </div>
    );
};

export default About;
